import { Icon, Stack } from "@chakra-ui/react"
import { formatAgo, isStale } from "lib/presence"
import { MdDone, MdWarningAmber } from "react-icons/md"

// "Last ping" / "Last sync" of a location: a green check while the time is recent, a red
// warning triangle when it is missing or older than 4 hours (see lib/presence.js).
export default function LastSeen({ value }) {
  const stale = isStale(value)
  return (
    <Stack direction='row' spacing={2} align='center'>
      <Icon h={4} w={4} as={stale ? MdWarningAmber : MdDone} color={stale ? 'red' : 'green'} />
      <div>{formatAgo(value)}</div>
    </Stack>
  )
}
